(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    import('@shopify/events').then(({ StandardEvents }) => {
if (!customElements.get('card-customization')) { // mobile image refined
  customElements.define('card-customization', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.form = this.closest('form');
      this.scope = this.closest('.shopify-section, dialog, product-card');
      this.variant = this.dataset.variant;
      this.pending = false;
      this.querySelector('[data-design-id]').value ||= (crypto.randomUUID ? crypto.randomUUID() : Date.now() + '-' + Math.random().toString(36).slice(2));
      this.addEventListener('change', (event) => {
        if (event.target.matches('[data-base]')) this.updateBorder();
        if (event.target.matches('[data-photo]')) this.checkPhoto();
        this.update();
      }, { signal });
      this.scope?.addEventListener(StandardEvents.productSelect, async (event) => {
        if (!this.scope.contains(event.target) || event.target.closest('product-card') && !event.target.closest('product-card').contains(this)) return;
        const generation = this.generation = (this.generation || 0) + 1;
        this.pending = true;
        this.querySelector('[data-status]').textContent = 'Updating your package…';
        try {
          const result = await event.promise;
          if (generation !== this.generation) return;
          this.variant = String(result?.detail?.resource?.id || '');
        } finally {
          if (generation === this.generation) {
            this.pending = false;
            this.querySelector('[data-status]').textContent = '';
            this.update();
          }
        }
      }, { signal });
      this.form?.addEventListener('submit', (event) => {
        this.update();
        this.checkPhoto();
        const requiredChecks = [
          ['[data-base]', 'Choose a card style before adding your card.'],
          ['select[name="properties[Art style]"]', 'Choose an art style before adding your card.'],
          ['input[name="properties[Main element]"]', 'Choose a main element before adding your card.'],
          ['input[name="properties[Hologram overlay]"]', 'Choose a hologram overlay before adding your card.'],
          ['[data-border]', 'Choose a border colour before adding your card.'],
          ['[data-other]:required', 'Enter your border colour before adding your card.'],
          ['[data-icon]:required', 'Choose a slab label icon before adding your card.'],
          ['[data-slab-border]:required', 'Choose a slab border colour before adding your card.'],
          ['[data-qr]:required', 'Enter the QR code website link before adding your card.'],
          ['[data-slab-other]:required', 'Enter your slab label border colour before adding your card.'],
          ['[data-photo]', 'Upload a photo before adding your card.'],
          ['input[name="properties[Details checked]"]', 'Confirm that you have checked the details before adding your card.'],
        ];
        for (const [selector, message] of requiredChecks) {
          const fields = [...this.querySelectorAll(selector)].filter((field) => !field.disabled);
          if (!fields.length) continue;
          const first = fields[0];
          const complete = first.type === 'radio' ? fields.some((field) => field.checked) : first.type === 'checkbox' ? first.checked : first.type === 'file' ? first.files?.length : Boolean(first.value.trim());
          if (!complete) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.querySelector('[data-status]').textContent = message;
            first.focus();
            return;
          }
        }
    if (this.pending || !this.form.reportValidity()) {
          event.preventDefault(); event.stopImmediatePropagation();
          if (this.pending) this.querySelector('[data-status]').textContent = 'Please wait for your package to finish updating, then add to cart.';
        }
      }, { capture: true, signal });
      this.update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      if(this.photoUrl) URL.revokeObjectURL(this.photoUrl);
    }
    show(selector, visible) {
      this.querySelectorAll(selector).forEach(container => {
        container.hidden = !visible;
        if(container.tagName === 'FIELDSET') container.disabled = !visible;
        container.querySelectorAll('input,select,textarea').forEach(input => input.disabled = !visible);
      });
    }
    updateBorder() {
      const base = this.querySelector('[data-base]').value;
      const choices = base === 'FULL ART TRAINER' ? ['Silver','Gold'] : base === 'TAG TEAM' ? ['Black','Blue','Green','Red','Orange','Pink','Purple','Yellow'] : ['Black','Blue','Green','Red','Orange','Pink','Purple','Gold','Silver','Other'];
      const border = this.querySelector('[data-border]');
      const previous = border.value;
      border.replaceChildren(new Option('Choose an option',''), ...choices.map(c => new Option(c,c)));
      border.value = choices.includes(previous) ? previous : '';
    }
    update() {
      const base = this.querySelector('[data-base]').value;
      const trainer = base === 'FULL ART TRAINER';
      this.show('[data-trainer]',trainer);
      this.show('[data-vmax]',base === 'VMAX');
      this.show('[data-battle]',!trainer);
      this.show('[data-element-wrap]',!trainer);
      this.querySelector('[data-trainer-element]').disabled = !trainer;
      const other = this.querySelector('[data-border]').value === 'Other';
      this.show('[data-other-wrap]',other);
      this.querySelector('[data-other]').required = other;
      const slab = String(this.variant) === '50554190856249';
      this.show('[data-slab]',slab);
      const qr = slab && this.querySelector('[data-icon]').value === 'Custom QR Code';
      this.show('[data-qr-wrap]',qr);
      this.querySelector('[data-qr]').required = qr;
      const slabOther = slab && this.querySelector('[data-slab-border]').value === 'Other';
      this.show('[data-slab-other-wrap]',slabOther);
      this.querySelector('[data-slab-other]').required = slabOther;
      this.querySelector('[data-photo-step]').textContent = slab ? '04' : '03';
    }
    checkPhoto() {
      const input = this.querySelector('[data-photo]');
      const file = input.files?.[0];
      const error = file && !['image/jpeg','image/png','image/webp','image/heic','image/heif'].includes(file.type) ? 'Please choose a JPG, PNG, WebP, or HEIC image.' : file && file.size > 10*1024*1024 ? 'Please choose an image smaller than 10 MB.' : '';
      input.setCustomValidity(error);
      this.querySelector('[data-file-error]').textContent = error;
      const preview = this.querySelector('[data-photo-preview]');
      if(this.photoUrl) URL.revokeObjectURL(this.photoUrl);
      preview.hidden = !file || !!error;
      if(file && !error) { this.photoUrl = URL.createObjectURL(file); preview.src = this.photoUrl; }
    }
  });
}
});
;(()=>{const run=()=>{const f=document.querySelector('.cc-form');if(!f||f.dataset.enhanced)return;f.dataset.enhanced='1';const h=document.createElement('section');h.className='cc-how-it-works';h.innerHTML='<h3>How it works</h3><div class="cc-how-grid"><div class="cc-how-step"><span class="cc-how-number">1</span><span><strong>Personalize it</strong><br>Choose your style, wording and photo.</span></div><div class="cc-how-step"><span class="cc-how-number">2</span><span><strong>Approve your proof</strong><br>Review the design and request changes.</span></div><div class="cc-how-step"><span class="cc-how-number">3</span><span><strong>We print and ship</strong><br>Production begins after approval.</span></div></div>';f.prepend(h);const s=[...f.querySelectorAll('.cc-section')],n=document.createElement('nav');n.className='cc-progress';n.ariaLabel='Customization progress';['Style','Wording','Slab label','Photo'].forEach((l,i)=>{if(!s[i])return;const b=document.createElement('button');b.type='button';b.textContent=(i+1)+'. '+l;if(!i)b.className='is-active';b.onclick=()=>s[i].scrollIntoView({behavior:'smooth'});n.appendChild(b)});h.after(n);const t=document.createElement('section');t.className='cc-trust';t.innerHTML='<div class="cc-trust-item"><strong>Proof before printing</strong><span>Check every detail before production.</span></div><div class="cc-trust-item"><strong>Changes are welcome</strong><span>Request adjustments from your private proof page.</span></div><div class="cc-trust-item"><strong>Made in Canada</strong><span>Prepared carefully for your order.</span></div>';const q=document.createElement('section');q.className='cc-faq';q.innerHTML='<h2>Frequently asked questions</h2><details><summary>When will I receive my proof?</summary><p>Your proof is sent before anything is printed.</p></details><details><summary>Can I request changes?</summary><p>Yes. Use the request-changes option on your private proof page.</p></details><details><summary>What photo works best?</summary><p>Use a clear, well-lit photo where faces are easy to see.</p></details><details><summary>When does printing begin?</summary><p>Printing begins only after you approve the final proof.</p></details><details><summary>Can I order different designs?</summary><p>Yes. Personalize and add each design separately.</p></details>';f.after(t,q);const a=document.querySelector('.product-form__submit,[id*=ProductSubmitButton]');if(a){const p=document.createElement('p');p.className='cc-proof-promise';p.textContent='✓ You will receive a proof to approve before printing.';a.before(p)}const w=document.createTreeWalker(document.body,NodeFilter.SHOW_TEXT);while(w.nextNode())if(w.currentNode.nodeValue.trim()==='Welcome to our store'){w.currentNode.nodeValue='Free shipping • Proof sent before printing';break}};document.readyState==='loading'?document.addEventListener('DOMContentLoaded',run):run();setTimeout(run,800)})();
// Customization enhancements v2
;(() => {
  const workerOrigin = 'https://custom-cards-proof-system.pokecardstudio.workers.dev';
  const initPhotoUpload = () => {
    const customizer = document.querySelector('card-customization.cc-form');
    const form = customizer?.closest('form');
    const photoInput = customizer?.querySelector('[data-photo]');
    const photoValue = customizer?.querySelector('[data-photo-value]');
    const status = customizer?.querySelector('[data-status]');
    if (!customizer || !form || !photoInput || !photoValue || customizer.dataset.photoUploadReady) return;

    customizer.dataset.photoUploadReady = '1';
    let uploadedPhotoUrl = '';
    let uploading = false;

    photoInput.addEventListener('change', () => {
      uploadedPhotoUrl = '';
      photoValue.value = '';
    });

    form.addEventListener('submit', (event) => {
      if (uploadedPhotoUrl || uploading) return;
      const photo = photoInput.files?.[0];
      if (!photo || !photoInput.validity.valid) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      uploading = true;
      if (status) status.textContent = 'Uploading your photo…';

      const payload = new FormData();
      payload.append('photo', photo, photo.name);
      fetch(workerOrigin + '/api/customer-upload', { method: 'POST', body: payload })
        .then(async (response) => {
          const result = await response.json().catch(() => ({}));
          if (!response.ok || typeof result.url !== 'string') {
            throw new Error(result.error || 'Photo upload failed. Please try again.');
          }
          uploadedPhotoUrl = result.url;
          photoValue.value = result.url;
          if (status) status.textContent = '';
          form.requestSubmit();
        })
        .catch((error) => {
          if (status) status.textContent = error instanceof Error ? error.message : 'Photo upload failed. Please try again.';
        })
        .finally(() => { uploading = false; });
    }, { capture: true });
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', initPhotoUpload)
    : initPhotoUpload();
  document.addEventListener('shopify:section:load', initPhotoUpload);
})();

;(() => {
  const workerOrigin = 'https://custom-cards-proof-system.pokecardstudio.workers.dev';
  const setupReliablePhotoUpload = () => {
    const customizer = document.querySelector('card-customization.cc-form');
    const form = customizer?.closest('form');
    const photoInput = customizer?.querySelector('[data-photo]');
    const photoValue = customizer?.querySelector('[data-photo-value]');
    const status = customizer?.querySelector('[data-status]');
    if (!customizer || !form || !photoInput || !photoValue || customizer.dataset.reliablePhotoUploadReady) return;
    customizer.dataset.reliablePhotoUploadReady = '1';
    let uploading = false;
    const uploadPhoto = async () => {
      const photo = photoInput.files?.[0];
      if (!photo || !photoInput.validity.valid || uploading) return false;
      uploading = true;
      photoValue.value = '';
      if (status) status.textContent = 'Uploading your photo…';
      try {
        const payload = new FormData();
        payload.append('photo', photo, photo.name);
        const response = await fetch(workerOrigin + '/api/customer-upload', { method: 'POST', body: payload });
        const result = await response.json().catch(() => ({}));
        if (!response.ok || typeof result.url !== 'string' || !/^https:\/\//.test(result.url)) throw new Error(result.error || 'Photo upload failed. Please try again.');
        photoValue.value = result.url;
        if (status) status.textContent = 'Photo uploaded — ready to add your card.';
        return true;
      } catch (error) {
        if (status) status.textContent = error instanceof Error ? error.message : 'Photo upload failed. Please try again.';
        return false;
      } finally {
        uploading = false;
      }
    };
    photoInput.addEventListener('change', () => {
      photoValue.value = '';
      uploadPhoto();
    });
    document.addEventListener('submit', async (event) => {
      if (event.target !== form) return;
      const photo = photoInput.files?.[0];
      if (!photo || !photoInput.validity.valid) return;
      if (uploading) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (status) status.textContent = 'Your photo is still uploading. Please wait a moment.';
        return;
      }
      if (!photoValue.value) {
        event.preventDefault();
        event.stopImmediatePropagation();
        const uploaded = await uploadPhoto();
        if (uploaded) form.requestSubmit();
        return;
      }
      event.stopImmediatePropagation();
    }, true);
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', setupReliablePhotoUpload) : setupReliablePhotoUpload();
  document.addEventListener('shopify:section:load', setupReliablePhotoUpload);
})();
  } catch(e) { console.error(e); }
})();

})();
